<template>
  <section ref="root" class="dc-container">
    <!-- papel rasgado -->
    <div class="rasgado rasgado-top"></div>

    <!-- FLORES EN ESQUINAS -->
    <img
      ref="florTopLeft"
      src="@/assets/florcoco1.png"
      alt="Flor decorativa"
      class="dc-flor flor-top-left"
    />
    <img
      ref="florBottomRight"
      src="@/assets/florcoco1.png"
      alt="Flor decorativa"
      class="dc-flor flor-bottom-right"
    />

    <!-- CONTENIDO -->
    <div class="dc-card">
      <!-- Título en dos líneas -->
      <h2 ref="title" class="dc-title">
        <span>Dress</span><br />
        <span class="script">Code</span>
      </h2>

      <!-- Etiqueta -->
      <div ref="badge" class="dc-badge"> FORMAL</div>

      <!-- Ilustración vestido / traje -->
      <img
        ref="figure"
        src="@/assets/codigo.png"
        alt="Dress code"
        class="dc-figure"
      />

      <!-- Nota -->
      <p ref="note" class="dc-note">
        Please reserve the colors Pink and Black exclusively for the Quinceañera.
      </p>

      <!-- 🔥 FRASE -->
      <p ref="fraseRef" class="dc-frase">  
      </p>

      <!-- 🔥 BOTAS -->
    

    </div>

    <div class="rasgado rasgado-bottom"></div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeLuxuryExact',
  setup() {
    const root = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)
    const note = ref(null)
    const fraseRef = ref(null)
    const botasRef = ref(null)
    const florTopLeft = ref(null)
    const florBottomRight = ref(null)

    onMounted(async () => {
      await nextTick()
      if (!root.value) return

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.value,
          start: 'top 85%',
          once: true
        }
      })

      // Animación de entrada para las flores (Rotación + Zoom-in elástico)
      if (florTopLeft.value && florBottomRight.value) {
        tl.from([florTopLeft.value, florBottomRight.value], {
          opacity: 0,
          scale: 0.4,
          rotation: (index) => (index === 0 ? -45 : 45),
          duration: 1,
          ease: 'back.out(1.5)',
          stagger: 0.15
        }, 0)
      }

      tl.from(title.value, {
        opacity: 0,
        y: -24,
        filter: 'blur(6px)',
        duration: 0.6,
        ease: 'power3.out'
      }, '<+=0.2')

      tl.from(
        badge.value,
        {
          opacity: 0,
          y: -16,
          scale: 0.98,
          duration: 0.5,
          ease: 'back.out(1.6)'
        },
        '>-0.1'
      )

      tl.from(
        figure.value,
        {
          opacity: 0,
          scale: 0.9,
          duration: 0.55,
          ease: 'power2.out'
        },
        '>-0.05'
      )

      if (note.value) {
        const words = note.value.innerText.split(' ')
        note.value.innerHTML = words.map(word => `<span class="word">${word}</span>`).join(' ')
        const wordSpans = note.value.querySelectorAll('.word')

        tl.from(
          wordSpans,
          {
            opacity: 0,
            y: 28,
            duration: 0.6,
            ease: 'power3.out',
            stagger: 0.12
          },
          '+=0.25'
        )
      }

      if (fraseRef.value) {
        const words = fraseRef.value.innerText.split(' ')
        fraseRef.value.innerHTML = words.map(word => `<span class="word">${word}</span>`).join(' ')
        const wordSpans = fraseRef.value.querySelectorAll('.word')

        tl.from(
          wordSpans,
          {
            opacity: 0,
            y: 30,
            scale: 0.95,
            duration: 0.7,
            ease: 'power3.out',
            stagger: 0.1
          },
          '+=0.4'
        )
      }

      // 🔥 BOTAS ANIMACIÓN
      if (botasRef.value) {
        tl.from(
          botasRef.value,
          {
            opacity: 0,
            y: 40,
            scale: 0.85,
            duration: 0.8,
            ease: 'back.out(1.7)'
          },
          '+=0.2'
        )
      }
    })

    onUnmounted(() => {
      ScrollTrigger.refresh()
    })

    return { root, title, badge, figure, note, fraseRef, botasRef, florTopLeft, florBottomRight }
  }
}
</script>

<style scoped>
.dc-container {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
  background: #eaadc0;
  padding: 34px 18px 42px;
  overflow: hidden;
  text-align: center;
}

.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 40px;
  background: #eaadc0;
  z-index: 1;
  pointer-events: none;
}
.rasgado-top {
  top: 0;
  clip-path: polygon(0% 70%, 18% 55%, 38% 78%, 58% 52%, 78% 75%, 100% 60%, 100% 0%, 0% 0%);
}
.rasgado-bottom {
  bottom: 0;
  clip-path: polygon(0% 30%, 18% 45%, 38% 22%, 58% 48%, 78% 25%, 100% 40%, 100% 100%, 0% 100%);
}

/* FLORES DECORATIVAS */
.dc-flor {
  position: absolute;
  width: 95px;
  height: auto;
  z-index: 3;
  pointer-events: none;
}

.flor-top-left {
  top: -15px;
  left: -45px;
  transform: rotate(-85deg);
}

.flor-bottom-right {
  bottom: -35px;
  right: -20px;
  transform: rotate(65deg);
}

.dc-card {
  position: relative;
  z-index: 2;
}

.dc-title {
  font-family: 'britishgruesa', cursive;
  font-size: 66px;
  color: #ffffff;
  margin: 0 0 16px;
  line-height: 1.05;
}

.dc-badge {
  display: inline-block;
  background: #ffffff;
  color: #333;
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 12px;
  letter-spacing: 0.14em;
  padding: 8px 16px;
  border-radius: 8px;
  margin: 4px 0 12px;
}

.dc-figure {
  width: 180px;
  margin: 10px auto 12px;
  display: block;
}

.dc-note {
  font-family: 'quote', serif;
  font-size: 24px;
  color: #ffffff;
  margin: 10px auto 18px;
}

.dc-frase {
  font-family: 'padres', serif;
  font-size: 28px;
  color: #ffffff;
  margin-top: 10px;
}

/* 🔥 BOTAS */
.dc-botas {
  width: 110px;
  margin: 16px auto 0;
  display: block;
  filter: drop-shadow(0 6px 12px rgba(0,0,0,.2));
}

.word {
  display: inline-block;
}
</style>